import { Fade, Snackbar as MuiSnackbar } from "@mui/material";
import type { ReactNode } from "react";

import type { SnackbarMessage } from "@/types/types";

type Props = {
  open: boolean;
  message?: ReactNode;
  type?: SnackbarMessage["type"];
  onClose: () => void;
  autoHideDuration?: number;
};

const typeToBgColorMapping: Record<
  NonNullable<SnackbarMessage["type"]>,
  string
> = {
  success: "var(--color-surface-accent-stronger)",
  error: "var(--color-zinc-800)",
  info: "var(--color-zinc-800)",
  warning: "var(--color-zinc-800)",
};

export function Snackbar({
  open,
  message,
  type = "info",
  onClose,
  autoHideDuration = 3000,
}: Props) {
  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={autoHideDuration}
      message={message}
      slots={{ transition: Fade }}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      slotProps={{
        content: {
          sx: {
            backgroundColor: typeToBgColorMapping[type],
          },
        },
      }}
    />
  );
}
